import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { UsageDashboard } from '@/components/features/admin/usage/UsageDashboard';
import { devToolsQueryOptions } from '@/hooks/use-dev-tool-toggle';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRoles } from '@/utils/roles';

const usageSearchSchema = z.object({
  tab: z.enum(['tokens', 'costs']).optional().catch(undefined),
});

export const Route = createFileRoute('/_protected/t/$tenantId/admin/usage')({
  validateSearch: usageSearchSchema,
  beforeLoad: async ({ context }) => {
    if (!userHasRoles(context.user, ['llm-usage-dashboard-admin', 'llm-usage-dashboard-viewer'])) {
      throw redirect({ to: '/' });
    }

    const devTools = await context.queryClient.ensureQueryData(devToolsQueryOptions());
    if (devTools.SHOW_BUSINESS_DASHBOARD) {
      throw redirect({ to: '/business-dashboard' });
    }
  },
  component: UsageRoute,
});

function UsageRoute() {
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <UsageDashboard />
    </ErrorBoundary>
  );
}
